package top.wcpe.allincore.ui.runtime.element

import top.wcpe.allincore.layout.engine.LayoutMode
import kotlin.jvm.JvmStatic

/**
 * 行容器：子元素水平排列。
 */
class Row private constructor() : UIElement<Row>() {

    init {
        styleField.layout().mode = LayoutMode.ROW
    }

    protected override fun self(): Row = this

    companion object {
        @JvmStatic
        fun create(): Row = Row()
    }
}
